// extracted by mini-css-extract-plugin
export default {"root":"LaOH_2o43nE1MmItG5xU","graphicElementWrapper":"Xgd3z8BdPBYnR_7RMeNV","text":"J1DILweBsbtjjpt3rlpx"};